module.exports = {
    getPlayerInfo: (json) => {
        const p = JSON.parse(json[1])
        return {
            playername: p.gpi.PN,
            level: p.gxp.LVL
        }
    },
    getLevel: (resp) => JSON.parse(resp[1]).LVL,
    lastTutorialLevel: 5,
    loginCmd: 'gbd',
    levelUpCmd: 'gxp',
    logoutCmd: 'LOGOUT'
}
